import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";

const sanitizeValue = (val, isMulti) => {
    if (isMulti) {
        if (!Array.isArray(val)) return [];
        return val.filter(
            (v) =>
                v &&
                typeof v === "object" &&
                v.value !== undefined &&
                v.label !== undefined
        );
    } else {
        if (Array.isArray(val)) return val[0] || null;
        if (val && typeof val === "object" && val.value !== undefined) return val;
        return null;
    }
};

const ProductSelect = ({
    value,
    onChange,
    loadProducts,
    isMulti = false,
    placeholder = "Select Product",
    onAddProduct,
    showAddProduct = true, // Default to true to maintain existing behavior
    cacheUniqs = [], // Added to clear cache when dependencies change
}) => {
    const safeValue = useMemo(() => sanitizeValue(value, isMulti), [value, isMulti]);

    return (
        <AsyncPaginate
            debounceTimeout={300}
            cacheUniqs={cacheUniqs}
            isMulti={isMulti}
            value={safeValue}
            loadOptions={async (search, loadedOptions, additional) => {
                const res = await loadProducts(search, loadedOptions, additional);
                let options = res?.options || [];

                // ➕ ADD PRODUCT OPTION
                if (showAddProduct && loadedOptions.length === 0 && !options.some(o => o.value === "__ADD_PRODUCT__")) {
                    options.unshift({
                        value: "__ADD_PRODUCT__",
                        label: "+ Add Product"
                    });
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                const selected = sanitizeValue(val, isMulti);
                if (isMulti) {
                    if (selected?.some(v => v.value === "__ADD_PRODUCT__")) {
                        if (onAddProduct) onAddProduct();
                        return;
                    }
                } else {
                    if (selected?.value === "__ADD_PRODUCT__") {
                        if (onAddProduct) onAddProduct();
                        return;
                    }
                }
                onChange(selected);
            }}
            placeholder={placeholder}
            additional={{ page: 1 }}
            menuPortalTarget={document.body}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                })
            }}
        />
    );
};

export default ProductSelect;
